// extracted by mini-css-extract-plugin
module.exports = {"root":"sidePanel_root__Cooxe","backdrop":"sidePanel_backdrop__4COl0","container":"sidePanel_container__ec8iY","right":"sidePanel_right__kSGIB"};